/**
 * app.js — Main entry point
 *
 * Import order:
 * 1. Styles  (Webpack extracts these into a separate CSS bundle)
 * 2. Vendors / polyfills
 * 3. Utilities
 * 4. Modules
 * 5. Components
 * 6. Page-level init
 */

// ─── Styles ───────────────────────────────────────────────────────────────────
import '../css/app.css';
import '@fortawesome/fontawesome-free/css/all.min.css';
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';

// ─── Modules ──────────────────────────────────────────────────────────────────
import Navbar from './components/Navbar.js';
import SmSlider from './components/SmSlider.js';
import LgSlider from './components/LgSlider.js';
import EpisodesSlider from './components/EpisodesSlider.js';
import ReplaysSlider from './components/ReplayesSlider.js'; 
import PopularSlider from './components/PopularSlider.js'; 
import RecentlyAddedSlider from './components/RecentlyAddedSlider.js';
import ScrollEffects from './modules/ScrollEffects.js';
import {
  fadeUpStagger,
  fadeIn,
  refreshScrollTrigger,
} from './modules/Animations.js';

import { prefersReducedMotion, qsa } from './utilities/Utilities.js';

// ─── Init ─────────────────────────────────────────────────────────────────────

const init = () => {
  // Core UI
  new Navbar();
  new SmSlider();
  new LgSlider();
  new EpisodesSlider();
  new ReplaysSlider();
  new PopularSlider();
  new RecentlyAddedSlider();
  new ScrollEffects();

  // Scroll animations — only when motion is acceptable
  if (!prefersReducedMotion()) {
    // Fade-up for any element marked [data-gsap="fade-up"]
    fadeUpStagger(qsa('[data-gsap="fade-up"]'));

    // Fade-in for any element marked [data-gsap="fade-in"]
    qsa('[data-gsap="fade-in"]').forEach((el) => fadeIn(el));

    // Refresh ScrollTrigger after all images have loaded
    window.addEventListener('load', refreshScrollTrigger, { once: true });
  }
};

// Run after DOM is parsed
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init, { once: true });
} else {
  init();
}
